module.exports = __webpack_public_path__ + "img/哈士奇钥匙扣-1.46aede29.jpg";